import React, { useState, useEffect } from "react";
import { Card, Table } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import { Sidebar } from 'primereact/sidebar';
import config from '../../config';
import { useClientAuth } from '../../context/ClientAuthContext';
import { Badge } from 'primereact/badge';
import { toWords } from "number-to-words";

const Old_CilentInvoices = () => {
    const { ClientId, apiRequest } = useClientAuth();
    const [loading, setLoading] = useState(true);
    const [invoices, setInvoices] = useState([]);
    const [visibleRight, setVisibleRight] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };



    const fetchInvoices = async () => {
        try {
            setLoading(true);
            const response = await apiRequest(
                `${config.apiBASEURL}/OldInvoiceRoutes/old-invoices-client-fetch/${ClientId}`,
                {
                    method: "GET",
                }
            );
            setInvoices(response.data.invoices || []);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchInvoices();
    }, [ClientId, apiRequest]);

    return (
        <>
            <div className="clintProfiletable">

                <Table responsive hover bordered size="sm">
                    <thead>
                        <tr className="table-primary sticky-top">
                            <th>Invoice Id</th>
                            <th style={{ width: '320px' }}>Client Details</th>
                            <th style={{ width: '320px' }}>Description</th>
                            <th>Currency</th>
                            <th style={{ width: '240px' }}>Amount</th>
                            <th>Issue Date</th>
                            <th style={{ width: '60px' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="text-center">Loading...</td>
                            </tr>
                        ) : invoices.length > 0 ? (
                            invoices.map((invoice) => (
                                <tr key={invoice.id} className={invoice.status === 2 ? "cancelled" : ""}>
                                    <td>{invoice.invoice}</td>
                                    <td>{invoice.clientinv?.Billing_name}
                                        <span className="d-block">
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-phone"
                                                rounded
                                                text
                                                severity="success"
                                                tooltip={invoice.clientinv?.phone}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-envelope"
                                                rounded
                                                text
                                                severity="primary"
                                                tooltip={invoice.clientinv?.email}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                        </span></td>
                                    <td>
                                        <p className="m-0"><small> </small> {invoice.template_name}</p>
                                        <p className="m-0"><small> </small> {invoice.remarks}</p>
                                    </td>
                                    <td>{invoice.currency}</td>
                                    <td>
                                        <p className="m-0"><small>Issue Date:  {new Date(invoice.issue_date).toLocaleDateString('en-GB')}</small> </p>
                                        <p className="m-0"><small className="text-danger">Due Date:    {new Date(invoice.due_date).toLocaleDateString('en-GB')}</small></p>
                                    </td>
                                    <td>
                                        <p className="m-0"><small>Cost: </small> <b>{invoice.sub_total}</b></p>
                                        {invoice.lut ? (
                                            <p className="m-0"><small>LUT ARN No: </small> <b>{invoice.templateinv?.Lut_Arn_No}</b></p>
                                        ) : (
                                            <>
                                                <p className="m-0"><small>Tax Type: </small> <b>{invoice.tax_type}</b></p>
                                                <p className="m-0"><small>Tax: </small> <b>{invoice.tax}</b></p>
                                            </>
                                        )}
                                        <p className="m-0"><small>Total: </small> <b>{invoice.total}</b></p>
                                    </td>
                                    <td style={{ width: '80px' }}>
                                        <Button
                                            icon="pi pi-eye"
                                            rounded
                                            text
                                            severity="help"
                                            aria-label="Bookmark"
                                            tooltip="View"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => {
                                                setSelectedInvoice(invoice); // Set the selected invoice
                                                setVisibleRight(true); // Show the sidebar/modal
                                            }}
                                        />

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    No records found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '50vw' }}>
                {selectedInvoice && (
                    <Card className='shadow-sm'>
                        <Card.Body className='p-0'>
                            <div className="inv-Div">
                                <div className="inv_header">
                                    <div className="logo_part">
                                        <img
                                            src={selectedInvoice.templateinv?.headerLogos[0]?.header_logo_url || require("../../assets/images/logo.png")}
                                            alt=''
                                        />
                                    </div>
                                    <span>
                                        <b>{selectedInvoice.templateinv?.header_text}</b>
                                    </span>
                                </div>
                                <div className="inv_address">
                                    <div>
                                        <p><span>BILLED TO :</span> {selectedInvoice.clientinv?.ClientDetails?.[0]?.bill_name || "N/A"}</p>
                                        <p><span>Address :</span> {selectedInvoice.clientinv?.ClientDetails?.[0]?.bill_address || "N/A"}</p>
                                        <p><span>GSTIN / UIN :</span> {selectedInvoice.clientinv?.ClientDetails?.[0]?.gstin || "N/A"}</p>
                                        <p><span>PAN / IT NO :</span> {selectedInvoice.clientinv?.ClientDetails?.[0]?.pan || "N/A"}</p>

                                    </div>
                                    <div>
                                        <p><span>PROFORMA NO :</span> {selectedInvoice.invoice}</p>
                                        <p><span>ISSUE DATE :</span> {new Date(selectedInvoice.issue_date).toLocaleDateString('en-GB')}</p>
                                        <p><span>GSTIN :</span> {selectedInvoice.templateinv?.GSTIN}</p>
                                        <p><span>PAN : </span> {selectedInvoice.templateinv?.PAN}</p>
                                        <p><span>MSME TYPE : </span> {selectedInvoice.templateinv?.MSME_Type}</p>
                                        <p><span>MSME NO : </span> {selectedInvoice.templateinv?.MSME_Number}</p>
                                        {selectedInvoice.lut && (
                                            <p><span>LUT ARN : </span> {selectedInvoice.templateinv?.Lut_Arn_No}</p>
                                        )}

                                    </div>
                                </div>
                                <div className="inv_cost">
                                    <Table bordered size="sm">
                                        <thead>
                                            <tr>
                                                <th>Description</th>
                                                <th>SAC/HSN</th>
                                                <th>QTY</th>
                                                <th className="text-end">Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedInvoice?.data?.map((product, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {product.description}
                                                    </td>
                                                    <td>{product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}</td>
                                                    <td>{product.qty}</td>
                                                    <td className="text-end">
                                                        <span>{product.price}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <th colSpan={3} className="text-end">Sub Total</th>
                                                <td className="text-end"><span>{getCurrencySymbol(selectedInvoice.currency)}</span>{selectedInvoice.sub_total}</td>
                                            </tr>

                                            <tr>
                                                <th colSpan={3} className="text-end">{selectedInvoice.tax_type} </th>
                                                <td className="text-end"><span>{getCurrencySymbol(selectedInvoice.currency)}</span>{selectedInvoice.tax}</td>
                                            </tr>



                                            <tr>
                                                <th colSpan={3} className="text-end">TOTAL VALUE (IN FIGURE) </th>
                                                <td className="text-end"><span>{getCurrencySymbol(selectedInvoice.currency)}</span>{selectedInvoice.total}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={3}>TOTAL VALUE (IN WORDS) </th>
                                                <td style={{ textTransform: 'capitalize' }}>{toWords(selectedInvoice.total)}</td>
                                            </tr>
                                            {/* <tr>
                                                <th colSpan={3}>SUPPLY ATTRACT REVERSE CHARGE (YES/NO)</th>
                                                <td >{selectedInvoice.supplyAttractReverses}</td>
                                            </tr> */}
                                            <tr>
                                                <th colSpan={3}>PAYMENT DUE DATE:</th>
                                                <td>{new Date(selectedInvoice.due_date).toLocaleDateString('en-GB')} </td>
                                            </tr>
                                            {selectedInvoice.lut && (
                                                <tr>
                                                    <th colSpan={3}>Without Payment of Tax under LUT No.</th>
                                                    <td>{selectedInvoice.templateinv?.Lut_Arn_No}</td>
                                                </tr>
                                            )}


                                        </tbody>
                                    </Table>
                                    <div className="noteText mb-4">

                                    </div>
                                    <div className="sign_sec mb-4">
                                        <div className="note_de">
                                            <p><b>Remarks :</b></p>
                                            <p>{selectedInvoice.remarks}</p>
                                            <p className="mt-3"><b>Declaration:</b></p>
                                            <p>
                                                We declare that this document shows the actual price of the good/services described and that all particulars are true and correct.
                                            </p>
                                        </div>
                                        <div className="sig">
                                            <p><b>E. & O.E</b></p>
                                            <img
                                                src={selectedInvoice.templateinv?.signatures[0]?.signature_url || require("../../assets/images/sign_n.png")}
                                                alt=''
                                                style={{ width: '80px', height: '80px' }}
                                            />
                                            <p><small>For THE GRAPHE</small></p>
                                        </div>
                                    </div>
                                    <div className="bankDet">
                                        <p><span className="d-block">PAYMENT INFORMATION :</span>PAY BY CHEQUE/DD/RTGS/NEFT IN FAVOUR OF {selectedInvoice.templateinv?.company_name || "N/A"} </p>
                                        <p><span className="d-block">BRANCH : </span> {selectedInvoice.templateinv?.bank_branch || "N/A"}</p>
                                        <p><span>BANK :</span> {selectedInvoice.templateinv?.bank_name || "N/A"}</p>
                                        <p><span>A/C NO  :</span> {selectedInvoice.templateinv?.account_number || "N/A"}</p>

                                        <p><span>IFSC CODE : </span> {selectedInvoice.templateinv?.ifsc_code || "N/A"}</p>
                                        <p><span>MSME NO : </span>  {selectedInvoice.templateinv?.MSME_Number || "N/A"}</p>
                                        <p><span>Swift Code : </span> {selectedInvoice.templateinv?.swift_code || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="pdf-footer mt-4">
                                    <p><small>{selectedInvoice.templateinv?.company_address || "N/A"}</small></p>
                                    <p><small>Call: {selectedInvoice.templateinv?.contact_no || "N/A"} | Email: <a >{selectedInvoice.templateinv?.email || "N/A"}</a></small></p>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                )}
            </Sidebar>
        </>
    );
}

export default Old_CilentInvoices
